/* eslint-disable camelcase */
import ToggleWeightCost from "@/components/toggleWeightCost/toggleWeightCost.vue";
import moment from "moment";
import chartOptions from "@/helpers/chartOptions";
import { Line } from "vue-chartjs";
import { createNamespacedHelpers } from "vuex";
import SvgRenderer from "@/components/svgRenderer/svgRenderer.vue";
import { formatNumberWithComma } from "@/utils";

const { mapGetters: userGetters } = createNamespacedHelpers("user"),
	{ mapGetters: brandingGetters } = createNamespacedHelpers("branding"),
	DIVIDER = 1000,
	DECIMALS = 2;

export default {
	extends: Line,

	props: { data: Object },

	components: {
		ToggleWeightCost,
		SvgRenderer,
	},

	data() {
		return {
			isCostToggleActive: false,
			DECIMALS,
		};
	},

	watch: {
		isCostToggleActive() {
			this.render();
		},
	},

	computed: {
		...userGetters(["activeOutlet", "weightUnit", "weightFactor"]),
		...brandingGetters(["colors"]),

		sinceLastMonthWeight() {
			return this.data.last_month_weight_saved / DIVIDER;
		},

		sinceLastMonthCost() {
			return this.data.last_month_cost_saved;
		},

		weightData() {
			return this.data.weight_saved / DIVIDER;
		},

		costData() {
			return this.data.cost_saved;
		},

		chartData() {
			const factor = this.isCostToggleActive ? 1 : this.weightFactor / DIVIDER;
			return {
				labels: this.data.per_month.map((month) => moment(month.month, "YYYY/MM").format("MMMM YYYY")),
				datasets: [
					{
						lineTension: 0,
						borderColor: this.colors[3],
						backgroundColor: "transparent",
						pointRadius: 4,
						pointBackgroundColor: this.colors[3],
						data: this.data.per_month.map((month) => month[this.chartDatasetElementProperty] * factor),
					},
				],
			};
		},

		chartDatasetElementProperty() {
			return this.isCostToggleActive ? "cost_saved" : "weight_saved";
		},
	},

	mounted() {
		this.render();
	},

	methods: {
		render,
		getChartLabel,
		getChartTooltip,
	},
};

function render() {
	const options = chartOptions.myGoalsYouHaveSaved();
	options.scales.yAxes[0].ticks.callback = this.getChartLabel;
	options.tooltips.callbacks.label = this.getChartTooltip;

	this.renderChart(this.chartData, options);
}

function getChartLabel(val) {
	if (this.isCostToggleActive) return `${this.activeOutlet.currency} ${formatNumberWithComma(val)}`;

	return `${formatNumberWithComma(val)} ${this.weightUnit}`;
}

function getChartTooltip(tooltipItem) {
	if (this.isCostToggleActive) {
		const cost = Number(tooltipItem.value);
		return `${this.activeOutlet.currency} ${formatNumberWithComma(cost, DECIMALS)}`;
	}

	const weight = Number(tooltipItem.value);
	return `${formatNumberWithComma(weight, DECIMALS)} ${this.weightUnit}`;
}
